import React, { useRef, useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';

import { CloseButton, Dialog, DialogActions, DialogContent, DialogTitle, SubmitButton } from 'components';
import { ServiceInterruptionForm } from 'forms';

interface ServiceInterruptionCreateDialogProps {
  visible?: boolean;
  setVisible?: (value: boolean) => void;
  title?: string;
  subtitle?: string;
  submitButtonLabel?: string;
}

export const ServiceInterruptionCreateDialog = ({
  visible = false,
  setVisible = () => {},
  title = 'New Service Interruption',
  subtitle = 'Log a comment explaining the reason for a service interruption. A service interruption can be for a specific zone or for the whole building. Comments will be included in the service zone report.',
  submitButtonLabel = 'Submit',
}: ServiceInterruptionCreateDialogProps) => {
  const theme = useTheme();
  const formRef = useRef<any>();
  const [loading, setLoading] = useState<boolean>(false);

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  const onSubmit = () => {
    formRef.current.onSubmit();
  };

  return (
    <Dialog open={visible} onClose={onClose} PaperProps={{ sx: { overflow: 'visible' } }}>
      <DialogTitle>
        <Box component="div">
          <Typography variant="h5">{title}</Typography>

          <Typography
            variant="body2"
            color="textSecondary"
            sx={{
              marginTop: 1,
            }}
          >
            {subtitle}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ paddingBottom: 0 }}>
        <ServiceInterruptionForm
          ref={formRef}
          onSubmitting={(loading) => setLoading(loading)}
          next={() => {
            onClose(null, 'anyway');
          }}
        />
      </DialogContent>

      <DialogActions sx={{ paddingBottom: 1 }}>
        <SubmitButton loading={loading} label={submitButtonLabel} onClick={onSubmit} />
      </DialogActions>

      <DialogContent sx={{ paddingBottom: 4 }}>
        <Typography variant="body2" color="textSecondary" sx={{ fontSize: 12, lineHeight: 1.3, fontStyle: 'italic' }}>
          Comments collected will be included in the{' '}
          <span style={{ color: theme.palette.primary.main }}>service zone report</span>.
        </Typography>
      </DialogContent>

      <CloseButton onClick={() => onClose(null, 'anyway')} />
    </Dialog>
  );
};
